import React from "react";
import {
  switchStyle,
  labelStyle,
  toggleStyle,
  toggleVariant,
} from "./switch.css";

export function Switch({ label = "", checked, ...rest }) {
  return (
    <label className={labelStyle}>
      <div
        className={`${toggleStyle} ${toggleVariant[checked ? "on" : "off"]}`}
      />
      <input
        type="checkbox"
        checked={checked}
        {...rest}
        className={switchStyle}
      />
      {label}
    </label>
  );
}
